{
  "name": "ui-plugin-app",
  "version": "1.30.0",
  "scripts": {
    "ng": "ng",
    "start": "ng serve --watch --open",
    "start-ssl": "ng serve --ssl --ssl-cert='./localhost.pem' --ssl-key='./localhost-key.pem' --watch --open",
    "build": "ng build --watch",
    "build-dev": "ng build",
    "build-prod": "ng build --configuration=prod",
    "serve-dist": "npx serve dist",
    "test": "ng test --code-coverage=true",
    "test-no-watch": "ng test --watch=false --code-coverage=true",
    "clean": "rm -fr coverage/ dist/",
    "lint": "npx eslint \"src/**/*.{js,jsx,ts,tsx,html}\" --quiet --fix",
    "format": "npx prettier \"src/**/*.{js,jsx,ts,tsx,html,css,scss}\" --write --log-level warn",
    "prepare": "husky"
  },
  "private": true,
  "dependencies": {
    "@angular/animations": "^18.2.7",
    "@angular/common": "^18.2.7",
    "@angular/compiler": "^18.2.7",
    "@angular/core": "^18.2.7",
    "@angular/forms": "^18.2.7",
    "@angular/localize": "^18.2.7",
    "@angular/platform-browser": "^18.2.7",
    "@angular/platform-browser-dynamic": "^18.2.7",
    "@angular/router": "^18.2.7",
    "@datadog/browser-logs": "^7.6.1",
    "@datadog/browser-rum": "^7.6.1",
    "@enliven/angular": "^2.10.0",
    "@fortawesome/angular-fontawesome": "^0.15.0",
    "@fortawesome/fontawesome-pro": "^6.5.2",
    "@fortawesome/fontawesome-svg-core": "^6.5.2",
    "@fortawesome/free-regular-svg-icons": "^6.5.2",
    "@fortawesome/free-solid-svg-icons": "^6.5.2",
    "@ng-bootstrap/ng-bootstrap": "^17.0.1",
    "@ng-select/ng-select": "^13.9.0",
    "@ngx-translate/core": "^15.0.0",
    "@ngx-translate/http-loader": "^8.0.0",
    "aws-amplify": "^6.3.4",
    "bootstrap": "^5.3.3",
    "ngx-translate-multi-http-loader": "^9.4.0",
    "rxjs": "^7.8.1",
    "tslib": "^2.3.0",
    "zone.js": "^0.14.3"
  },
  "devDependencies": {
    "@angular-devkit/build-angular": "^18.2.7",
    "@angular-eslint/builder": "^18.3.1",
    "@angular-eslint/eslint-plugin": "^18.3.1",
    "@angular-eslint/eslint-plugin-template": "^18.3.1",
    "@angular-eslint/schematics": "^18.3.1",
    "@angular-eslint/template-parser": "^18.3.1",
    "@angular/cli": "^18.2.7",
    "@angular/compiler-cli": "^18.2.7",
    "@faker-js/faker": "^9.3.0",
    "@types/jasmine": "~5.1.0",
    "@typescript-eslint/eslint-plugin": "^7.7.0",
    "@typescript-eslint/parser": "^7.7.0",
    "eslint": "^8.57.0",
    "eslint-config-prettier": "^9.1.0",
    "eslint-plugin-prettier": "^5.1.3",
    "husky": "^9.0.11",
    "jasmine-core": "~5.1.0",
    "jwt-encode": "^1.0.1",
    "karma": "~6.4.0",
    "karma-chrome-launcher": "~3.2.0",
    "karma-coverage": "~2.2.0",
    "karma-jasmine": "~5.1.0",
    "karma-jasmine-html-reporter": "~2.1.0",
    "karma-spec-reporter": "^0.0.36",
    "typescript": "~5.4.2"
  }
}
